import {
    ComboBox,
    ComboBoxBlurEvent,
    ComboBoxChangeEvent,
    ComboBoxFilterChangeEvent,
    ComboBoxProps
} from "@progress/kendo-react-dropdowns";
import {ApiResponseDto, DropDownListItem} from "@utils/Models";
import React, {useCallback, useEffect, useRef, useState} from "react";
import axios from "axios";
import {FlintValidationData} from "@utils/AppConstants";
import {Error} from "@progress/kendo-react-labels";

export default function FlintRemoteDataComboBox<T extends DropDownListItem>(props: FlintRemoteDataComboBoxProps<T>) {
    const pendingRequest = useRef<any>(undefined);
    const requestStarted = useRef(false);
    const [data, setData] = useState<T[]>([]);
    //const skipRef = useRef(0);

    const {
        baseUrl,
        onChange,
        minFilterLength = 3,
        onFilterChange: ofc,
        dataItemKey = "Id",
        textField = "Name",
        validationData,
        filterParamName = "filter",
        maxLength,
        ...other
    } = props;

    const requestData = useCallback((filter: string) => {
        if (requestStarted.current) {
            clearTimeout(pendingRequest.current);
            pendingRequest.current = setTimeout(() => {
                requestData(filter);
            }, 50);
            return;
        }
        requestStarted.current = true;
        const params = {[filterParamName]: filter, ...props.parameters};
        axios.get<ApiResponseDto<T[]>>(baseUrl, {params: params})
            .then((response) => {
                const items = response.data.Result;
                if (!items || !(items instanceof Array<T>))
                    return;
                setData(items);
            }).catch((error) => {
            console.error(error);
        }).finally(() => {
            requestStarted.current = false;
        });
    }, [props.parameters]);

    function handleOnChange(e: ComboBoxChangeEvent) {
        if (props.onChange)
            props.onChange(e);
        props.onItemSelected(e.value);
    }

    const onFilterChange = useCallback((event: ComboBoxFilterChangeEvent) => {
        if (!event.filter.value || event.filter.value.length < minFilterLength)
            return;
        const filter = event.filter.value;
        requestData(filter);
    }, [minFilterLength, props.parameters]);

    useEffect(() => {
        console.info(props.parameters);
    }, [props.parameters])
    const emptyItem: DropDownListItem = {Name: 'loading ...', Id: 0};
    const pageSize = 50;
    const loadingData: DropDownListItem[] = [];
    while (loadingData.length < pageSize) {
        loadingData.push({...emptyItem});
    }
    const handleBlur = (event: ComboBoxBlurEvent) => {
        validationData?.validateFunction?.(validationData?.optionalObjectToValidate).catch((err) => {});
        if (props.onBlur) {
            props.onBlur(event); // Call the parent's onBlur handler if provided
        }
    };
    return <div className="flint-text-box">
        <ComboBox
            allowCustom={true}
            filterable={true}
            data={data}
            dataItemKey={dataItemKey}
            textField={textField}
            onChange={handleOnChange}
            onFilterChange={onFilterChange}
            onBlur={handleBlur}
            {...other}
        />
        {(!props.valid && props.validationMessage) && <Error>{props.validationMessage}</Error>}
        {validationData?.validationMessage != null && <Error>{validationData.validationMessage}</Error>}
    </div>
}

export interface FlintRemoteDataComboBoxProps<T extends DropDownListItem> extends ComboBoxProps {
    baseUrl: string;
    onItemSelected: (item: T) => void;
    minFilterLength?: number;
    parameters?: any;
    filterParamName?: string;
    validationData?: FlintValidationData;
    maxLength?: number;
}